import styled from 'styled-components';
import { Container as Button } from '../buttons/Button.style';

export const Container = styled.div`
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 20px 45px 20px 20px;
  margin-bottom: 30px;
  display: flex;
  color: ${({ theme }) => theme.textDark};
  gap: 15px;
`;

export const TextContent = styled.div`
  h3 {
    font-size: 20px;
  }

  & > p {
    color: ${({ theme }) => theme.textLight};
    line-height: 1.2;
  }

  h3 a:hover {
    text-decoration: underline;
  }

  ${Button} {
    margin-top: 10px;
    max-width: 200px;
  }
`;

export const CheckCircle = styled.button<{ $checked: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 23px;
  border: 1px solid ${({ theme, $checked }) => ($checked ? theme.textDark : theme.keyline)};
  position: absolute;
  top: 15px;
  right: 15px;
  background-color: ${({ theme, $checked }) => ($checked ? theme.textDark : theme.background)};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BrowseLinks = styled.div`
  a {
    display: block;
    color: ${({ theme }) => theme.primary};
    margin-top: 10px;

    &:hover {
      text-decoration: underline;
    }
  }
`;
